import { Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { LabelField } from 'components'
import { Chip } from 'components/chips'
import * as controllers from 'controllers'
import { InboundTripDto, InboundTripPAPSDto } from 'dtos'
import React from 'react'
import { formatAddress } from 'utils'

interface InboundTripPAPSDetailsCardProps {
  inboundTrip: InboundTripDto
  inboundTripPAPS: InboundTripPAPSDto
}

export default function InboundTripPAPSDetailsCard({
  children,
  inboundTrip,
  inboundTripPAPS
}: React.PropsWithChildren<InboundTripPAPSDetailsCardProps>) {
  return (
    <Card>
      <CardContent>
        <Grid container spacing={2} alignItems='flex-start'>
          <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
            <Grid item xs={12} sm='auto' container spacing={1}>
              <Grid item>
                <Typography fontWeight='bold' variant='h5'>
                  PAPS #{inboundTripPAPS.papsNumber}
                </Typography>
              </Grid>

              {inboundTripPAPS.isLocked && (
                <Grid item>
                  <Chip variant='red'>Locked</Chip>
                </Grid>
              )}
            </Grid>

            <Grid item xs={12} sm='auto' container>
              {children}
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12} sm={4}>
            <LabelField label='Exporter Company' value={inboundTripPAPS.exporterCompany?.name} />
          </Grid>

          <Grid item xs={12} sm={4}>
            <LabelField label='Buyer Company' value={inboundTripPAPS.buyerCompany?.name} />
          </Grid>

          <Grid item xs={12} sm={4}>
            <LabelField label='Vehicle Destination Company' value={inboundTripPAPS.vehicleDestinationCompany?.name} />
          </Grid>

          <Grid item xs={12} sm={4}>
            <LabelField
              label='Vehicle Destination Company Address'
              value={
                inboundTripPAPS.vehicleDestinationCompanyAddress
                  ? formatAddress(inboundTripPAPS.vehicleDestinationCompanyAddress)
                  : ''
              }
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <LabelField label='Title Destination Company' value={inboundTripPAPS.titleDestinationCompany?.name} />
          </Grid>

          <Grid item xs={12} sm={4}>
            <LabelField
              label='Title Destination Company Address'
              value={
                inboundTripPAPS.titleDestinationCompanyAddress
                  ? formatAddress(inboundTripPAPS.titleDestinationCompanyAddress)
                  : ''
              }
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <LabelField
              ellipsis
              label='Pro Forma'
              onClick={() => {
                if (inboundTrip.inboundTripGuid && inboundTripPAPS.inboundTripPAPSGuid && inboundTripPAPS.proFormaFileName) {
                  controllers.inboundTrips.getInboundTripPAPSProForma(
                    inboundTrip.inboundTripGuid,
                    inboundTripPAPS.inboundTripPAPSGuid
                  )
                }
              }}
              value={inboundTripPAPS.proFormaFileName}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <LabelField
              ellipsis
              label='Foreign Shippers'
              onClick={() => {
                if (
                  inboundTrip.inboundTripGuid &&
                  inboundTripPAPS.inboundTripPAPSGuid &&
                  inboundTripPAPS.foreignShippersFileName
                ) {
                  controllers.inboundTrips.getInboundTripPAPSForeignShippers(
                    inboundTrip.inboundTripGuid,
                    inboundTripPAPS.inboundTripPAPSGuid
                  )
                }
              }}
              value={inboundTripPAPS.foreignShippersFileName}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <LabelField
              label='Signed Foreign Shippers'
              onClick={() => {
                if (
                  inboundTrip.inboundTripGuid &&
                  inboundTripPAPS.inboundTripPAPSGuid &&
                  inboundTripPAPS.signedForeignShippersFileName
                ) {
                  controllers.inboundTrips.getInboundTripPAPSSignedForeignShippers(
                    inboundTrip.inboundTripGuid,
                    inboundTripPAPS.inboundTripPAPSGuid
                  )
                }
              }}
              value={inboundTripPAPS.signedForeignShippersFileName}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
